import { ShieldCheck } from "lucide-react";

function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-gray-200 bg-white/70 backdrop-blur-2xl mt-auto">
      {/* Background Glow */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute bottom-[-80px] left-[10%] w-[220px] h-[220px] bg-cyan-200/20 rounded-full blur-3xl" />

        <div className="absolute top-[-60px] right-[15%] w-[180px] h-[180px] bg-blue-200/20 rounded-full blur-3xl" />
      </div>

      {/* Grid Effect */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.02)_1px,transparent_1px)] bg-[size:40px_40px]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          {/* Left */}
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-2xl bg-cyan-50 border border-cyan-100 flex items-center justify-center shadow-sm">
              <ShieldCheck
                size={16}
                className="text-cyan-600"
              />
            </div>

            <div className="text-center md:text-left">
              <p className="text-sm font-medium text-gray-800">
                Engineering Strategic Digital Platform
              </p>

              <p className="text-[11px] text-gray-500">
                Secure Internal Engineering System
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="flex flex-col md:items-end items-center">
            <p className="text-xs text-gray-500">
              © 2026 All Rights Reserved.
            </p>

            <p className="text-[10px] text-gray-400 mt-1 tracking-wide uppercase">
              Version 1.0.0
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
